import React from "react";
import { Stack, Divider } from "@mui/material";
import Stat from "./Stat";
import { LineChartData } from "../../types";
import { aggregateStatsSummary } from "./utils";
import { AggregatedStatsKey } from "./types";

type StatSummaryProps = {
  datasets: LineChartData["datasets"];
  colors: string[];
  unit: string;
};

const translationKeyMap: Record<AggregatedStatsKey, string> = {
  current: "Current",
  min: "Min",
  max: "Max",
  average: "Average",
};

const StatsSummary = ({ datasets, colors, unit }: StatSummaryProps) => {
  const aggregatedStatsData = aggregateStatsSummary(datasets);
  const statDataEntries = Object.entries(aggregatedStatsData);

  return (
    <Stack
      direction="row"
      divider={<Divider orientation="vertical" variant="middle" flexItem />}
      sx={{
        alignItems: "center",
        gap: 1
      }}>
      {statDataEntries.map(([key, values]) => (
        <Stat
          key={key}
          translationKey={translationKeyMap[key as AggregatedStatsKey]}
          values={values}
          colors={colors}
          unit={unit}
        />
      ))}
    </Stack>
  );
};

export default StatsSummary;
